/**
 * The nearest `data-testid` to a RUM click action's DOM event: the clicked element's own, or the
 * closest ancestor's when the click landed on an icon or span inside a button. RUM only records a
 * click's text, so this is what lets a replayed session find the same element automated tests do.
 */
export const getClickActionTestId = (domEvents: Event[] | undefined): string | undefined => {
    const target = domEvents?.[0]?.target;
    if (!(target instanceof Element)) {
        return undefined;
    }
    return target.closest<HTMLElement>("[data-testid]")?.dataset.testid || undefined;
};
